import { betActions } from '../../../store/slices/bets/slice';
import { gameStateActions } from '../../../store/slices/game/slice';
import type { GameCommunicationMessageType, GameCommunicationMetaType } from '../types';
import { ConnectionStatus, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreGameInitGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.GameInit;
  public delay = 0;

  // This message is sent once the game socket is established for the first time AND for each 'hard' re-connection
  public process(
    message: GameCommunicationMessageType,
    _store: never,
    _sender: never,
    { connectionStatus }: GameCommunicationMetaType
  ): void {
    const gameId = this.store.getState().gameState.gameId;
    const newGameId = message.gId as string;

    const fromReconnect =
      connectionStatus === ConnectionStatus.RECONNECTING || connectionStatus === ConnectionStatus.RECONNECTED;

    if (fromReconnect && gameId !== newGameId) {
      this.store.dispatch(gameStateActions.setGameId(newGameId));
      this.store.dispatch(betActions.resetBetStack());
    }
  }
}
